import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** `cn` helper — standard shadcn utility. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  const k = n / 1024;
  if (k < 1024) return `${k.toFixed(1)} KB`;
  const m = k / 1024;
  if (m < 1024) return `${m.toFixed(2)} MB`;
  return `${(m / 1024).toFixed(2)} GB`;
}
